import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ARInvoice } from '../../models/ar-invoice.model';

@Component({
    selector: 'app-open-invoices',
    templateUrl: './open-invoices.component.html',
    styleUrls: ['./open-invoices.component.scss'],
    standalone: false
})
export class OpenInvoicesComponent {
  @Input() invoices: ARInvoice[] = [];
  @Input() internId: string = '';
  @Output() selectedInvoiceRecordNo = new EventEmitter<string>();

   displayedColumns: string[] = [
    'recordId', 'datePosted', 'invoiceAmount', 'totalDue', 'paymentAmount'
  ];
 currency = 'USD';
  constructor () { }

  viewInvoice(invoice: ARInvoice): void {
    this.selectedInvoiceRecordNo.emit(invoice.recordNo);
  }

  trackByFn = (_: number, row: any) => row.recordId;
}
